export const editor = {

    data: {
        editor: null
    }
}

export default editor;
